import styled from 'styled-components';

import { HOME_NARROW, MOBILE, SPACE } from '../../../../theme/tokens';

/** Three cards to a row, two at Home's narrow width, one on a phone; cards in a row share its height. */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${SPACE[16]};
  align-items: stretch;

  ${HOME_NARROW} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${MOBILE} {
    grid-template-columns: minmax(0, 1fr);
  }
`;
